export default "__VITE_ASSET__BSLZGwrk__"